module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-1.dc0102d7.png";